import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SapAmountTypeService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  SapAmountTypeCreateDto,
  SapAmountTypeDto,
  SapAmountTypeExcelDownloadDto,
  SapAmountTypeUpdateDto,
} from '../proxy/controlling/dtos/sap-amount-type';
import { SAPAMOUNTTYPE_CONFIG, SAPAMOUNTTYPE_FIELDS } from './sap-amount-type.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-sap-amount-type',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, SapAmountTypeService, ConfirmationService],
  templateUrl: './sap-amount-type.html',
  styleUrl: './sap-amount-type.scss',
})
export class SapAmountType extends BaseHierarchicalCrudComponent<
  SapAmountTypeDto,
  SapAmountTypeCreateDto,
  SapAmountTypeUpdateDto,
  SapAmountTypeExcelDownloadDto
> {
  service = inject(SapAmountTypeService);
  config = SAPAMOUNTTYPE_CONFIG;
  fields = SAPAMOUNTTYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: SapAmountTypeDto): SapAmountTypeUpdateDto {
    return {
      ...data,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'SapAmountType';
  }
}
